import { ManagerProgressionCategorySlug } from '@sorare/core/src/__generated__/globalTypes';

import frameCollector from './assets/frame_collector.svg';
import frameCommon from './assets/frame_common.svg';
import frameInfluencer from './assets/frame_influencer.svg';
import frameLimited from './assets/frame_limited.svg';
import frameOnboarding from './assets/frame_onboarding.svg';
import frameRare from './assets/frame_rare.svg';
import frameSuperRare from './assets/frame_super-rare.svg';
import frameTactician from './assets/frame_tactician.svg';
import frameUnique from './assets/frame_unique.svg';
import frameUnrivalled from './assets/frame_unrivalled.svg';

export const PARAMETERS_PER_CATEGORY: Partial<
  Record<
    ManagerProgressionCategorySlug,
    {
      frameUrl: string;
      colorFrom: string;
      colorTo: string;
      notReverse?: boolean;
    }
  >
> = {
  [ManagerProgressionCategorySlug.COLLECTOR]: {
    frameUrl: frameCollector,
    colorFrom: '#A80AD2',
    colorTo: '#26112D',
  },
  [ManagerProgressionCategorySlug.COMMON_PRO]: {
    frameUrl: frameCommon,
    colorFrom: '#FFFFFF',
    colorTo: '#292929',
  },
  [ManagerProgressionCategorySlug.LIMITED_PRO]: {
    frameUrl: frameLimited,
    colorFrom: '#F8D39A',
    colorTo: '#47320F',
  },
  [ManagerProgressionCategorySlug.RARE_PRO]: {
    frameUrl: frameRare,
    colorFrom: '#F37760',
    colorTo: '#6D0D05',
  },
  [ManagerProgressionCategorySlug.SUPER_RARE_PRO]: {
    frameUrl: frameSuperRare,
    colorFrom: '#9DB2FF',
    colorTo: '#262C44',
  },
  [ManagerProgressionCategorySlug.UNIQUE_PRO]: {
    frameUrl: frameUnique,
    colorFrom: '#DA8CF5',
    colorTo: '#320255',
  },
  [ManagerProgressionCategorySlug.INFLUENCER]: {
    frameUrl: frameInfluencer,
    colorFrom: '#C699FE',
    colorTo: '#3E1870',
  },
  [ManagerProgressionCategorySlug.ONBOARDING]: {
    frameUrl: frameOnboarding,
    colorFrom: '#41FFDD',
    colorTo: '#01241E',
  },
  [ManagerProgressionCategorySlug.UNRIVALLED]: {
    frameUrl: frameUnrivalled,
    colorFrom: '#01DCD5',
    colorTo: '#000000',
  },
  [ManagerProgressionCategorySlug.TACTICIAN]: {
    frameUrl: frameTactician,
    notReverse: true,
    colorFrom: '#3DDC84',
    colorTo: '#000000',
  },
};
